module.exports = __webpack_public_path__ + "img/zebra.a54db13c.jpeg";